(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('AutomaticAnswersService', AutomaticAnswersService);

  AutomaticAnswersService.$inject = ['$resource'];

  function AutomaticAnswersService ($resource) {
    return $resource(apiUrl + '/automatic-answers/all-cards/', {}, {
      all: { method: 'GET', params: {}, isArray: false },
      invoiceCopy: { url: apiUrl + '/automatic-answers/invoice-copy', method: 'POST', params: {}, isArray: false },
      latestReleases: { url: apiUrl + '/automatic-answers/latest-releases', method: 'POST', params: {}, isArray: false },
      limit: { url: apiUrl + '/automatic-answers/limits', method: 'POST', params: {}, isArray: false }
    });
  }
})();
